export function withoutPoolRef(judges, refName) {
  const seen = new Set();
  return (judges || []).filter((name) => {
    if (!name || name === refName || seen.has(name)) return false;
    seen.add(name);
    return true;
  });
}
